// extracted by mini-css-extract-plugin
module.exports = {"comments":"Z_dJ","comments__list":"Z_dK"};